module.exports = {
  IN_QUEUE: 'in_queue',
  PENDING: 'pending',
  SENT: 'sent',
  FAILED: 'failed',
};
